export default {
  breakpoints: {
    xs: 0,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1440,
  },

  primaryColor: 'rgb(25,63,125)',
  primaryColorOverlay: '#00467D20',
  primaryColorLight: '#006fa7',
  white: '#fff',
  black: '#000',
  darkGray: '#646464',
  gray: '#DEDEDE',
  lightGray: '#F0F0F0',
  red: '#D20A11',
  yellow: '#EBBE3C',
  green: '#5A734B',

  spacingVertical: (multiplier = 1, number = false) => (number ? 10 * multiplier : `${10 * multiplier}px`),
  spacingHorizontal: (multiplier = 1, number = false) => (number ? 15 * multiplier : `${15 * multiplier}px`),

  // Todo: define
  fontBig: '26px',
  fontMedium: '22px',
  fontSmall: '18px',
};
